module.exports = __webpack_public_path__ + "static/robotic-mowers_in_rest-dbb9f659ab234cd4b0881831c9dd34c4.jpg";